export const ComponentStatusMap = {
    default: 1,
    todo: 1,
    inProgress: 2,
    inReview: 3,
    complete: 4,
    rejected: 5,
    problems: 6,
};

export const ComponentStatuses = {
    Todo: {
        value: ComponentStatusMap.todo,
        label: { text: 'To do' },
        text: 'To do',
        css: 'bg-grey',
    },
    InProgress: {
        value: ComponentStatusMap.inProgress,
        label: { text: 'In Progress' },
        text: 'In Progress',
        css: 'bg-blue',
    },
    InReview: {
        value: ComponentStatusMap.inReview,
        label: { text: 'In Review' },
        text: 'In Review',
        css: 'bg-yellow',
    },
    Complete: {
        value: ComponentStatusMap.complete,
        label: { text: 'Complete' },
        text: 'Reviewed',
        css: 'bg-green',
    },
    Problems: {
        value: ComponentStatusMap.problems,
        label: { text: 'Problems' },
        text: 'Problems',
        css: 'bg-amber',
    },
    Rejected: {
        value: ComponentStatusMap.rejected,
        label: { text: 'Rejected' },
        text: 'Rejected',
        css: 'bg-red',
    },
};

export const ComponentStatusFromId = (id) => {
    if (!id) return ComponentStatuses.Todo;

    return Object.values(ComponentStatuses).find((x) => x.value == id);
};
